import { render } from "./SaleCustomersTable.vue?vue&type=template&id=5ff36db3&scoped=true"
import script from "./SaleCustomersTable.vue?vue&type=script&lang=js"
export * from "./SaleCustomersTable.vue?vue&type=script&lang=js"

import "./SaleCustomersTable.vue?vue&type=style&index=0&id=5ff36db3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff36db3"]])

export default __exports__